import React, { Fragment } from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { EngagementMenuItem } from './EngagementMenuItem';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';

export interface ObservingDealsMenuItemProps {
    engagements?: any[];
}

export const ObservingDealsMenuItem = (props: ObservingDealsMenuItemProps) => {
    const engagements = props.engagements ?? [];
    const items = engagements.filter(
        (engagement) => engagement.party === TimelineParty.Observer
    );

    return (
        <Fragment>
            <LeftMenuItem
                icon="pe-7s-plugin"
                label="Observing Deals"
                className="app-sidebar__heading vertical-nav-menu custom "
                marginLeft={-10}
                stateIcon="pe-7s-plugin"
                trackingAction="Observing Deals"
            />
            {items.map((engagement, index) => (
                <EngagementMenuItem key={index} engagement={engagement} />
            ))}
        </Fragment>
    );
};
